<template>
  <div>
    <div class="search-box">
      <div class="tip-box">
        <img
          src="@/assets/images/new_icon_waring_yellow.png"
          style="
            display: inline-block;
            float: left;
            position: absolute;
            width: 14px;
            height: 14px;
            color: #ffffff;
            margin: 14px 4px 0 3px;
          "
        />
        <span style="margin-left: 24px; color: #333"
          >此功能为京东官方功能，必须报备店铺签名后才可以筛选出数据，营销效果分析需要第二天才可以查看！</span
        >
        <span
          :style="{ color: globalBG }"
          style="cursor: pointer"
          @click="toSet"
          >去设置</span
        >
      </div>
      <el-form
        ref="formSearch"
        :inline="true"
        :model="form"
        label-width="120px"
      >
        <el-form-item label="活动主题:">
          <el-input
            size="small"
            v-model="form.activityTitle"
            placeholder="请输入活动主题"
          ></el-input>
        </el-form-item>
        <el-form-item label="短信类型:">
          <el-select size="small" v-model="form.smsType">
            <el-option value="" label="全部" />
            <el-option :value="0" label="普通短信" />
            <el-option :value="1" label="富信" />
            <el-option :value="2" label="卡片短信" />
          </el-select>
        </el-form-item>
        <el-form-item label="短信内容:">
          <el-input
            size="small"
            v-model="form.content"
            placeholder="请输入短信内容"
          ></el-input>
        </el-form-item>
        <el-form-item label="发送状态:">
          <el-select size="small" v-model="form.sendStatus">
            <el-option
              v-for="(item, index) in sendStatusList"
              :key="index"
              :value="item.value"
              :label="item.label"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="提交时间:">
          <div class="my_select_time">
            <el-date-picker
              prefix-icon="no_icon"
              v-model="form.subStartTime"
              type="datetime"
              :placeholder="'选择日期时间'"
              size="small"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 120px; font-size: 12px"
              class="time1"
              :clearable="false"
            ></el-date-picker>
            <div class="time_to_text" style="margin-top: 1px !important">
              至
            </div>
            <el-date-picker
              prefix-icon="no_icon"
              v-model="form.subEndTime"
              type="datetime"
              :placeholder="'选择日期时间'"
              size="small"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 145px; font-size: 12px"
              class="time2"
              :clearable="false"
            ></el-date-picker>
            <i
              class="el-icon-circle-close date_icon1"
              @click="clearTime1()"
            ></i>
            <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
          </div>
        </el-form-item>

        <el-form-item label="发送时间:">
          <div class="my_select_time">
            <el-date-picker
              prefix-icon="no_icon"
              v-model="form.sendStartTime"
              type="datetime"
              :placeholder="'选择日期时间'"
              size="small"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 120px; font-size: 12px"
              class="time1"
              :clearable="false"
            ></el-date-picker>
            <div class="time_to_text" style="margin-top: 1px !important">
              至
            </div>
            <el-date-picker
              prefix-icon="no_icon"
              v-model="form.sendEndTime"
              type="datetime"
              :placeholder="'选择日期时间'"
              size="small"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 145px; font-size: 12px"
              class="time2"
              :clearable="false"
            ></el-date-picker>
            <i
              class="el-icon-circle-close date_icon1"
              @click="clearTimeSendTime()"
            ></i>
            <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
          </div>
        </el-form-item>
      </el-form>
      <div class="el_btn">
        <el-button
          size="small"
          :disabled="tableLoding"
          class="search"
          @click="form.current = 1;submitForm('formSearch')"
        >
          <i
            class="el-icon-search"
            style="display: inline-block; width: 14px; height: 12px"
          ></i>
          查询
        </el-button>
        <el-button size="small" class="reset" @click="resetForm"
          >重置</el-button
        >
      </div>
    </div>
    <div class="table-box">
      <div style="color: #fe4d45; padding-bottom: 5px; margin-left: 30px">
        注意：短信扣费先按照提交条数预扣相应短信条数，余额会减少，发送后4~7天会按照京东实际返回的短信状态报告成功扣费，短信条数多退少补。
      </div>
      <el-table
        ref="table"
        :data="tableData"
        v-loading="tableLoding"
        tooltip-effect="light"
        style="width: 100%; border: 1px solid #eee"
      >
        <template slot="empty">
          <div>
            <img src="@/assets/images/default/暂无任何数据.png" />
            <span style="margin-left: -140px">暂无任何数据</span>
          </div>
        </template>
        <el-table-column
          label="序号"
          type="index"
          width="80px"
        ></el-table-column>
        <el-table-column label="短信类型" width="80px">
          <template slot-scope="scope">
            <span v-if="scope.row.smsType == 0">普通短信</span>
            <span v-else-if="scope.row.smsType == 1">富信</span>
            <span v-else-if="scope.row.smsType == 2">卡片短信</span>
          </template>
        </el-table-column>
        <el-table-column
          label="活动主题"
          prop="activityTitle"
          width="300"
        ></el-table-column>
        <el-table-column key="activiveType" label="活动类型">
          <template>智能营销</template>
        </el-table-column>
        <el-table-column
          key="content"
          label="短信内容"
          min-width="120px"
          prop="content"
          width="400"
        >
          <template slot="header" slot-scope="scope">
            <span>短信内容</span>
            <span
              v-if="!allShow"
              :style="{ color: globalBG }"
              @click="allShow = true"
              class="table-message"
              >(展开全部)</span
            >
            <span
              v-if="allShow"
              :style="{ color: globalBG }"
              @click="allShow = false"
              class="table-message"
              >(单行显示)</span
            >
          </template>
          <template slot-scope="scope">
            <div>
              <el-tooltip
                class="item"
                effect="light"
                :content="scope.row.mediaTitle"
                placement="top"
                 v-if="scope.row.smsType == 1"
              >
                <div class="hoveTitle" v-show="!allShow" style="color: #9485ed;cursor: pointer;" @click="showMediaInfo(scope.row)">
                  {{ scope.row.mediaTitle }}
                </div>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="light"
                :content="scope.row.mediaTitle"
                placement="top"
                 v-else-if="scope.row.smsType == 2"
              >
                <div class="hoveTitle" v-show="!allShow" style="color: #9485ed;cursor: pointer;" @click="showCardInfo(scope.row)">
                  {{ scope.row.mediaTitle }}
                </div>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="light"
                :content="scope.row.content"
                placement="top"
                v-else
              >
                <div class="hoveTitle" v-show="!allShow">
                  {{ scope.row.content }}
                </div>
              </el-tooltip>
              <div class="hoveTitleShowMore" v-show="allShow"  v-if="scope.row.smsType == 1" style="color: #9485ed;cursor: pointer;"  @click="showMediaInfo(scope.row)"> 
                {{ scope.row.mediaTitle }}
              </div>
              <div class="hoveTitleShowMore" v-show="allShow" v-else-if="scope.row.smsType == 2" style="color: #9485ed;cursor: pointer;"  @click="showCardInfo(scope.row)">
                {{ scope.row.mediaTitle }}
              </div>
              <div class="hoveTitleShowMore" v-show="allShow" v-else>
                {{ scope.row.content }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column key="selectedCrowd" width="400" label="活动对象">
          <template slot="header" slot-scope="scope">
            <span>活动对象</span>
            <span
              v-if="!allShowCrowd"
              :style="{ color: globalBG }"
              @click="allShowCrowd = true"
              class="table-message"
              >(展开全部)</span
            >
            <span
              v-if="allShowCrowd"
              :style="{ color: globalBG }"
              @click="allShowCrowd = false"
              class="table-message"
              >(单行显示)</span
            >
          </template>
        <template slot-scope="scope" v-if="scope.row.activeObject">
            <div>
              <el-tooltip
                class="item"
                effect="light"
                :content="scope.row.activeObject"
                placement="top"
              >
                <div class="hoveTitle" v-show="!allShowCrowd">
                  {{ scope.row.activeObject }}
                </div>
              </el-tooltip>
              <div class="hoveTitleShowMore" v-show="allShowCrowd">
                {{ scope.row.activeObject }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="提交时间"
          key="subTime"
          width="160px"
          prop="subTime"
        ></el-table-column>
        <el-table-column label="发送状态" key="sendStatus">
          <template slot-scope="scope">
            <span>
              {{ scope.row.sendStatus == "1" ? "待审核" : "" }}
              {{ scope.row.sendStatus == "3" ? "待发送" : "" }}
              {{ scope.row.sendStatus == "4" ? "审核未通过" : "" }}
              {{ scope.row.sendStatus == "5" ? "已取消" : "" }}
              {{ scope.row.sendStatus == "100" ? "发送中" : "" }}
              {{ scope.row.sendStatus == "101" ? "已发送" : "" }}
              {{ scope.row.sendStatus == "102" ? "发送失败" : "" }}
            </span>
            <el-tooltip
              class="item"
              effect="light"
              :content="scope.row.failMessage"
              placement="top-start"
              v-if="
                scope.row.sendStatus == '4' || scope.row.sendStatus == '102'
              "
            >
              <span
                class="question_icon"
                style="color: #fe4d45 !important; border-color: #fe4d45"
                >?</span
              >
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          label="发送时间"
          key="sendTime"
          prop="sendTime"
          width="160px"
        ></el-table-column>
        <el-table-column
          key="sendSubmitNum"
          label="提交人数"
          prop="sendSubmitNum"
        ></el-table-column>
        <el-table-column
          key="feeCount1"
          label="预扣费条数"
          prop="feeCount"
        ></el-table-column>
        <el-table-column
          label="短信量"
          prop="feeCount"
          key="feeCount2"
        ></el-table-column>
        <el-table-column
          label="实际发送人数"
          key="sendNum2"
          prop="sendNum"
          width="150"
        >
          <template slot="header" slot-scope="scope">
            <span>实际发送人数</span>
            <el-tooltip
              class="item"
              effect="light"
              content="短信发送完成后京东会返回实际发送人数"
              placement="top-start"
            >
              <span class="question_icon">?</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column key="realFeeCount" prop="realFeeCount" width="150">
          <template slot="header" slot-scope="scope">
            <span>实际扣费条数</span>
            <el-tooltip
              class="item"
              effect="light"
              content="实际扣费条数京东官方会在发送后2天返回，发送后未返回显示--，发送失败显示0，已发送会显示具体扣费条数；"
              placement="top-start"
            >
              <span class="question_icon">?</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          label="退回条数"
          key="refundCount"
          prop="refundCount"
          width="150"
        >
          <template slot="header" slot-scope="scope">
            <span>退回条数</span>
            <el-tooltip
              class="item"
              effect="light"
              content="根据京东官方通道实际返回的状态报告结算，状态报告失败的会退回相应条数；"
              placement="top-start"
            >
              <span class="question_icon">?</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="180">
          <template slot-scope="scope">
            <div class="btns-type">
             <span v-if="isPremissionShow">
              <el-button type="text"
                class="operation"
                v-if="scope.row.sendStatus=='101'"
                @click="secondMarketingFn(scope.row)"
                >二次营销
              </el-button>
              <el-button type="text" disabled style="color: #dddddd" v-else>二次营销</el-button>
             </span>
            <el-button
              class="operation"
              type="text"
              v-if="scope.row.sendStatus == 1 || scope.row.sendStatus == 3"
              @click="handleCancelPrecision(scope.row, scope.$index)"
            >
              取消发送</el-button
            >
            <el-button
              class="operation"
              v-if="!(scope.row.sendStatus == 1 || scope.row.sendStatus == 3)"
              type="text"
              style="color: #dddddd"
              >取消发送</el-button
            >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div>
        <el-pagination
          background
          style="text-align: right; margin-top: 20px"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="form.current"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="form.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="crowdTotal"
        ></el-pagination>
      </div>
    </div>
    <!-- 富信模板 -->
    <sms-info 
      v-if="smsInfoShow" 
      @close="smsInfoShow = false" 
      :isShow="smsInfoShow" 
      :id="smsInfoId"
      :title="smsInfoTitle"
      :text="smsInfoText"
    />
    <sms-info-card v-if="smsInfoCardShow" :isShow="smsInfoCardShow" @close="smsInfoCardShow = false" :id="cardId"></sms-info-card>
  <!-- 二次营销弹窗 -->
  <second-marketing :secondMarketingVisible="secondVisible" :recordId="recordId" :activityTitle="activityTitle" :secondSource="secondSource" :smsType="smsType" v-if="secondVisible" @close="secondVisible = false"></second-marketing>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getSmsRecordPage, cancelSendSms } from "@/api/intelligentMarket/index";

import smsInfo from '@/components/sms-info'
import smsInfoCard from '@/components/sms-info-card'
import secondMarketing from "@/components/secondMarketing.vue";

export default {
  components: {
    smsInfo,
    smsInfoCard,
    secondMarketing
  },
  props:{
    searchform:{
      type: Object,
    }
  },
  name: "",
  data() {
    return {
      smsType: 0,
      isPremissionShow: false,
      activityTitle: "",
      secondSource: 1,
      recordId: "",
      secondVisible: false,
      cardId:null,
      smsInfoCardShow:false,
      form: {
        size: 10,
        current: 1,
        activityTitle: "",
        content: "",
        sendStatus: "",
        subStartTime: "",
        subEndTime: "",
        sendStartTime: "",
        sendEndTime: "",
        smsType: "",
      },
      allShow: false,
      allShowCrowd: false,
      sendStatusList: [
        {
          label: "全部",
          value: '',
        },
        {
          label: "待审核",
          value: 1,
        },
        {
          label: "待发送",
          value: 3,
        },
        {
          label: "审核未通过",
          value: 4,
        },
        {
          label: "已取消",
          value: 5,
        },
        {
          label: "发送中",
          value: 100,
        },
        {
          label: "已发送",
          value: 101,
        },
        {
          label: "发送失败",
          value: 102,
        },
      ],
      tableData: [],
      tableLoding: false,
      crowdTotal: 0,
      mytimestart:"",
      mytimeend:"",
      smsInfoShow: false, // 富信
      smsInfoId: "", // 富信id
      smsInfoTitle: "", // 富信标题
      smsInfoText: "", // 富信内容
    };
  },
  computed: {
    ...mapState({
      globalBG: "globalBG",
    }),
    permissions() {
      return this.$store.getters.loginUserInfo.permissions;
    },
  },
  watch: {
    permissions: {
      handler(nVal, oVal) {
        if (nVal&&nVal.length&&nVal.indexOf("hide:second:market") != "-1") {
          // 显示二次营销按钮
          this.isPremissionShow = true;
        }
      },
      immediate: true
    },
  },
  mounted() {
    this.time();


    if(this.searchform){
      console.log("this.searchform",this.searchform)
      this.form.activityTitle = this.searchform.activityName
      this.form.marketingId = this.searchform.id
      this.form.current = 1;
      this.clearTime1()
      this.submitForm('formSearch')
    }else{
      this.form.marketingId = ''
      this.queryList();
    }
  },
  methods: {
    secondMarketingFn(row) {
      this.recordId = row.id
      this.activityTitle = row.activityTitle
      this.smsType = row.smsType
      this.secondVisible = true
    },
    showMediaInfo(row) {
      this.smsInfoShow = true
      this.smsInfoId = row.mediaMulitiFileId
      this.smsInfoTitle = row.mediaTitle
      this.smsInfoText = row.content
    },
    showCardInfo(row){
      this.cardId = row.mediaTemplateId;
      this.smsInfoCardShow = true;
    },
     time() {
      let yy = new Date().getFullYear(); //当前年份
      let mm =
        new Date().getMonth() + 1 < 10
          ? "0" + (new Date().getMonth() + 1)
          : new Date().getMonth() + 1;
      let dd =
        new Date().getDate() < 10
          ? "0" + new Date().getDate()
          : new Date().getDate(); //当前天数
      this.mytimestart = `${yy}-${mm}-${dd} 00:00:00`;
      this.mytimeend = `${yy}-${mm}-${dd} 23:59:59`;
      this.form.subStartTime = this.getDateStr(-30) + " 00:00:00";
      this.form.subEndTime = this.mytimeend;
    },
    queryList() {
      this.tableLoding = true;
      getSmsRecordPage(this.form).then((res) => {
        this.tableLoding = false;
        if (res.code == "1") {
          this.tableData = res.data.records;
          this.crowdTotal = res.data.total;
        }
      });
    },
    handleSizeChange(val) {
      this.form.size = val;
      this.form.current = 1;
      this.submitForm();
    },
    handleCurrentChange(val) {
      this.form.current = val;
      this.submitForm();
    },

    submitForm(name) {
      this.queryList();
      // console.log(this.form.current)
    },
    resetForm() {
      this.searchform = {}
      this.form = {
        size: 10,
        current: 1,
        activityTitle: "",
        content: "",
        sendStatus: "",
        subStartTime: "",
        subEndTime: "",
        sendStartTime: "",
        sendEndTime: "",
        marketingId:"",
      };
      this.queryList();
    },
    // 精准营销的取消发送
    handleCancelPrecision(row, index) {
      this.$confirm("确定要取消吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass: "iconfont iconicon-jinggao1",
      }).then(() => {
        var param = {
          sellerNick: row.sellerNick,
          // activityRecordId: row.activityRecordId,
          id: row.id,
        };
        cancelSendSms(param).then((res) => {
          if (res.code == "1") {
            this.$message.success("取消发送成功");
            this.submitForm();
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },

    toSet() {
      let routeUrl = this.$router.resolve({
        path: "/backstage/signature_management/signature_report_official",
      });
      window.open(routeUrl.href, "_blank");
    },
    clearTime1() {
      console.log(111111);
      this.form.subStartTime= "";
      this.form.subEndTime= ""
      console.log(this.form);
    },
    clearTimeSendTime() {
      this.form.sendStartTime= "";
      this.form.sendEndTime= ""
      console.log(this.form);
    },
  },
};
</script>

<style scoped lang="scss">
/deep/ .el-dialog .el-dialog__body {
  padding-bottom: 24px;
}
/deep/ .el-table th.is-leaf {
  height: 50px;
}
/** 表单搜索  */
.search-box {
  margin-top: 20px;
  padding-bottom: 20px;
  .el_btn {
    text-align: center;
    .search {
      width: 98px;
      height: 32px;
      font-size: 14px;
      border-radius: 3px;
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff;
      &:hover {
        color: #fff;
        border: 1px solid #fff;
        background-color: #fe4d45;
      }
    }
    .reset {
      width: 98px;
      height: 32px;
      font-size: 14px;
      border-radius: 3px;
      color: #666666;
      border: 1px solid #dddddd;
      background-color: #fff;
      &:hover {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
    }
  }
  .el-input,
  .el-select {
    width: 280px;
  }
  .my_select_time {
    display: flex;
    align-items: center;
  }
}
/** 表格内容 */
.table-box {
  // margin: 20px;
  margin-top: 20px;
  padding: 0 28px 24px 28px;
  .control-button {
    .el-button {
      width: 65px;
      margin-left: 0 !important;
    }
    .operation {
      cursor: pointer;
      color: #7f85e9;
      &:hover {
        color: #fe4d45;
      }
    }
  }
}
.btns-type {
  display: flex;
}
.question_icon {
  width: 14px;
  height: 14px;
  color: #7f85e9 !important;
  display: inline-block;
  line-height: 12px !important;
  text-align: center;
  border-radius: 14px;
  border: 1px solid #7f85e9;
  font-size: 12px !important;
  font-weight: normal !important;
  margin-left: 8px;
  &:hover {
    color: #fe4d45 !important;
    border: 1px solid #fe4d45;
  }
}
/* 短信记录/效果分析  */
.tip-box {
  padding-left: 24px;
  text-align: left;
  line-height: 21px;
  font-size: 14px;
  margin-top: 12px;
  color: #999999;
  background: #fffaee;
  position: relative;
  margin: 20px 28px 20px 28px;
  line-height: 42px;
  .warning-icon {
    color: #fe8f8a;
    font-size: 14px;
    position: absolute;
    left: 5px;
    top: 13px;
  }
}
</style>